import type * as Eden from '@eden';
import { CapabilityScope } from '@eden';
import { HEADERS } from '@util/constants';

export type AllowedCapabilityTokenType<R extends Eden.Routes[keyof Eden.Routes]> = R extends {
    allowedCapabilities: readonly CapabilityScope[];
}
    ? R['allowedCapabilities'][number] | CapabilityScope.NONE
    : undefined;

export type CapabilityParam<T> = [T] extends [CapabilityScope]
    ? {
          capabilityToken: Eden.CapabilityToken<T>;
      }
    : { capabilityToken?: undefined };

export function getCapabilityTokenHeader<T extends CapabilityScope>(
    token?: Eden.CapabilityToken<T>,
): Record<string, string> {
    if (token && token.type !== CapabilityScope.NONE) {
        return {
            [HEADERS.CapabilityToken]: token.token,
        };
    }
    return {};
}
